import React from 'react';

export const NashLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="124.8 335.1 384.6 407.1"
    fill="none"
    {...props}
  >
    <path
      d="M136.001 422.8C136.001 422.8 185.101 450.7 192.401 455.1C287.501 513 361.701 486.6 363.001 412.2V344.5C363.001 338.7 369.301 335.1 374.301 338L503.601 412.6C505.301 413.6 506.701 414.9 507.801 416.5C507.801 416.5 507.801 416.7 507.901 416.7C507.901 416.7 508.001 416.8 508.101 416.9C508.901 418.6 509.401 420.5 509.401 422.5V571.7C509.401 577.5 503.101 581.1 498.101 578.2L439.401 544.4C374.301 508.2 314.301 559.3 316.901 670.7C317.101 679.2 316.701 735.7 316.701 735.7C316.701 741.5 310.401 745.1 305.401 742.2L130.701 641.3C128.901 640.3 127.501 638.9 126.401 637.3C126.401 637.3 126.401 637.1 126.301 637.1C126.301 637.1 126.201 637 126.101 636.9C125.201 635.1 124.801 633.2 124.801 631.2V429.4C124.801 423.6 131.101 420 136.101 422.9L136.001 422.8Z"
      fill="#C9FF00"
    />
  </svg>
);
